import { Injectable, ComponentRef } from '@angular/core';
import { OverlayRef, Overlay, OverlayConfig, ComponentType } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

export interface OverlayPanelInfo {
  overlayRef: OverlayRef;
  componentRef: ComponentRef<any>;
}

@Injectable({
  providedIn: 'root'
})
export class OverlayPanelsService {

  private overlayRefs: OverlayRef[] = [];

  constructor(private overlay: Overlay) { }

  createPanel(component: ComponentType<any>, config: OverlayConfig): OverlayPanelInfo {
    let overlayRef = this.overlay.create(config);
    let componentRef = overlayRef.attach(new ComponentPortal(component));
    
    this.overlayRefs.push(overlayRef);

    return { overlayRef: overlayRef, componentRef: componentRef };
  }

  closeAll() {
    for (let or of this.overlayRefs)
      or.dispose();
    this.overlayRefs = [];
  }
}
